export const homeNotificationMessage: Record<string, string> = {
  warning: "Failed to load video",
};
